<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-5">
<h1>Chapter 5</h1>
<p>At lunch, Crystal, Sophie and I sat in the sun, tanning our bleached white legs.</p>
<p>‘There you are!’ announced Ashleigh flopping down beside me, ‘I’m sorry I’ve been ignoring you. Will you forgive me?’</p>
<p>We looked at her suspiciously. Why the sudden reconnection?</p>
<p>‘I feel really bad. I miss you guys.’</p>
<p>‘What’s going on, Ash?’ Sophie asked.</p>
<p>‘Umm, it’s Steve,’ she replied sounding dejected.</p>
<p>‘And?’</p>
<p>‘We hear you two are together?’ blurted Crystal.</p>
<p>‘In my opinion, we’re just good mates though he’s putting the hard word on me and I don’t feel comfortable.’</p>
<p>‘Really? Because to everyone else, it looks like you’re an item.’</p>
<p>‘You have a right to say <em>No!</em> Ashleigh,’ Crystal was straight down the line. ‘Steve has no respect for women. In my opinion, he’s only interested in one thing; “use them and lose them.”’</p>
<p>Crystal paused before going off on a tangent. ‘Give me a guy who’s going to be around for the long haul. I want a guy who knows when you’re cranky each month and gives you space. Or buys you flowers for no special occasion. Sends you sweet messages and doesn’t want anything in return, especially naked photos.’</p>
<p>‘I want someone I can trust. Someone I can be myself with and not have to pretend or a guy who doesn’t judge or put me down,’ I added. ‘And doesn’t pressure you into drugs, alcohol or sex.’</p>
<p>‘I want the fairy-tale we read as children,’ agreed Ashleigh.</p>
<p>‘The same romantic qualities also apply for a girl,’ said Sophie randomly.</p>
<p>We looked at her. What <em>was</em> she implying; that a guy looked for similar traits in a girlfriend that we wanted in a guy? Or was there something else? Luckily, Soph clarified her statement.</p>
<p>‘I think I’m gay,’ she announced.</p>
<p>Crystal and I looked at each other. Did we tell her we already suspected? Maybe not.</p>
<p>‘Okay, no judgement but can I ask,’ I kept my voice monotone, ‘Why do you think you’re gay?’</p>
<p>‘I’m not interested in guys,’ Soph said matter-of-factly, ‘Apologies Ashleigh, but not even Steve.’</p>
<p>‘Have you told your parents?’ I inquired.</p>
<p>‘They wouldn’t care either way. As long as I’m happy and healthy that’s all that matters.’</p>
<p>‘Maybe you should have that conversation with them?’ I suggested trying to sound vague rather than pushy.</p>
<p>‘One day, it’s not critical; just thought I’d put it out there,’ Soph grinned and sounded relieved, ‘And for the record, I’m not romantically interested in any of you.’</p>
<p>‘That’s good,’ laughed Crystal, ‘because I’m definitely straight!’</p>
<p>Ashleigh waited patiently until there was a gap in the conversation.</p>
<p>‘Sophie, I’m glad you’ve had that realisation, but I <em>really</em> need to talk to you all and get your advice about Steve,’ Ashleigh spoke as she quickly scanned the yard ensuring we were alone.</p>
<p>‘Okay, shoot,’ said Crystal encouragingly.</p>
<p>‘Honestly, if you don’t want to sleep with him, tell him,’ said Sophie interrupting.</p>
<p>‘It’s <em>not</em> about sex. It’s far worse than that. He’s dealing drugs and wants me to experiment.’</p>
<p>‘Whether it’s sex or drugs, I hope you said,’<em>No</em>!’</p>
<p>‘Trust me I did. Drugs are so wrong,’ Ash hesitated before adding, ‘What I’m about to say I think you need to know, Jess.’</p>
<p>My stomach flipped. ‘What?’</p>
<p>‘Holly bought drugs from Steve.’</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch009.vue?9c43f3d8